<template>
  <div class="table-crud-modal" ref="addModal">
    <h2 class="lvl2-heading">Nous contacter</h2>
    <el-form
      ref="addVideoForm"
      :model="params"
      label-position="left"
      :status-icon="true"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="lastname">
            <span>Nom:*</span>
            <el-input
              :disabled="true"
              v-model="params.lastname"
              placeholder="Nom"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="firstname">
            <span>Prénom:*</span>
            <el-input
              :disabled="true"
              v-model="params.firstname"
              placeholder="Prénom"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item prop="email">
            <span>Email:*</span>
            <el-input
              :disabled="true"
              v-model="params.email"
              placeholder="Email"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item prop="subject">
            <span>Sujet:*</span>
            <el-input v-model="params.subject" placeholder="Sujet"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item prop="message">
            <span>Message:*</span>
            <el-input
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 7 }"
              v-model="params.message"
              placeholder="Message "
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item style="text-align: right">
        <base-button @click.prevent.stop.native="handleSubmit" :fluid="false"
          >Envoyer
        </base-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { Input, Form, FormItem, Message, Row, Col } from "element-ui"
import { loaderMixin } from "@/mixins"
import { contactUs } from "@/api/users"
export default {
  components: {
    ElInput: Input,
    ElFormItem: FormItem,
    ElForm: Form,
    ElRow: Row,
    ElCol: Col
  },
  mixins: [loaderMixin],
  data() {
    return {
      params: {
        lastname: null,
        firstname: null,
        email: null,
        subject: null,
        message: null
      },
      rules: {
        lastname: [
          {
            trigger: "blur",
            required: true,
            message: "Le nom est obligatoire"
          }
        ],
        firstname: [
          {
            trigger: "blur",
            required: true,
            message: "Le prénom est obligatoire"
          }
        ],
        email: [
          {
            trigger: "blur",
            required: true,
            message: "L'email est obligatoire"
          }
        ],
        subject: [
          {
            trigger: "blur",
            required: true,
            message: "Le sujet est obligatoire"
          }
        ],
        message: [
          {
            trigger: "blur",
            required: true,
            message: "Le message est obligatoire"
          }
        ]
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs["addVideoForm"].validate(valid => {
        if (valid) {
          this.openLoader(this.$refs.addModal)

          contactUs(this.params)
            .then(response => {
              Message({
                message: response.message,
                type: "success",
                duration: 5 * 1000
              })
              this.closeLoader()
              this.$store.dispatch("closeModal")
            })
            .catch(() => {
              this.closeLoader()
            })
        } else {
          return false
        }
      })
    }
  },
  created() {
    let user_info = this.$store.state.user.info
    if (user_info) {
      this.params.firstname = user_info.first_name
      this.params.lastname = user_info.last_name
      this.params.email = user_info.email
    }
  }
}
</script>
